export default __webpack_public_path__ + "static/media/icons_AGE platform-01.6feff067.svg";